import { Button as AntButton } from 'antd';
import clsx from 'clsx';
import type { ButtonHTMLAttributes, MouseEvent } from 'react';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  /** Defaults to "button" so buttons inside forms never submit by accident. */
  type?: 'button' | 'submit' | 'reset';
}

const SIZE = { sm: 'small', md: 'middle', lg: 'large' } as const;

/** Same API as before, rendered by Ant Design. */
export function Button({ variant = 'secondary', size = 'md', loading = false, className, children, disabled, type = 'button', onClick, style, ...rest }: ButtonProps) {
  const antType = variant === 'primary' || variant === 'danger' ? 'primary' : variant === 'ghost' ? 'text' : 'default';
  return (
    <AntButton
      htmlType={type}
      type={antType}
      danger={variant === 'danger'}
      size={SIZE[size]}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={clsx(`btn-${variant}`, className)}
      style={style}
      onClick={onClick as (e: MouseEvent<HTMLElement>) => void}
      {...(rest as Record<string, unknown>)}
    >
      {loading ? <span className="spinner" aria-hidden="true" /> : null}
      {children}
    </AntButton>
  );
}
